import UserModal from './UserModal';

export default UserModal;
